// Angular
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject, ViewChild, ViewRef, ElementRef, HostListener, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// NGRX
// Service
//Models
import { LayoutUtilsService } from '../../../../../../core/_base/crud';
import { DatePipe } from '@angular/common';
import { FunctionPublic } from 'app/views/pages/nfc/dung-chung/__function/common_function';
import { ConstantsExport } from 'app/views/pages/nfc/chuc-nang-kho-page/kho-xuat-kho-page/kho-xuat-kho-page-model/kho-xuat-kho-page.model';


@Component({
	selector: 'kt-xuat-kho-tra-ncc-171123',
	templateUrl: './xuat-kho-tra-ncc-171123.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})


export class XKTraNCC171123PrintComponent implements OnInit {
	dataPBDNOnly: any = [];
	dataPBSDOnly: any = [];
	dataBPSDOnly: any = [];
	details: any = [];

	@Input() masterData: any;
	@Input() set detailData(data) {
		if (!data) return;
		data.forEach(item => {
			if (!this.dataPBDNOnly.includes(item.TenBPDN))
				this.dataPBDNOnly.push(item.TenBPDN);
			if (!this.dataPBSDOnly.includes(item.TenBPSD))
				this.dataPBSDOnly.push(item.TenBPSD);
			if (!this.dataBPSDOnly.includes(item.NameNewBPSD))
				this.dataBPSDOnly.push(item.NameNewBPSD);
		});
		this.details = data;
	}
	now = new Date();
	constructor(
		private datePipe: DatePipe) {};
		
	/**
	 * On init
	 */
	ngOnInit() {
	}
	
	// .. Function dùng chung mặc định
	FormatDatetime(datetime) {
		return this.datePipe.transform(datetime, 'dd/MM/yyyy');
	}
	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}
	// ................................

	// .. Tính tổng số lượng | Không phân biệt đơn vị
	sumQuantities(){
		var totalQuantity = 0;
		this.details.forEach(item => {
			totalQuantity += item.SoLuongQuiDoi;
		})
		return this.f_number(totalQuantity);
	}
	// ...............................................

	// .. Check Lý do đang chọn là 'Xuất trả nhà cung cấp'
	selectedReasonSupplierReturn(){
		return this.masterData.Lydocode == ConstantsExport.EXPORT_SUPPLIER_RETURN;
	}
	// .. Check Lý do đang chọn là 'Khác'
	selecedOtherReason(){
		return this.masterData.Lydocode == null;
	}
	// .. Lấy tên nhà cung cấp theo chi tiết phiếu
	supplierInfo(){
		const details = this.details;
		var supplier = [];
		details.forEach(item => {
			if (item.SupplierName && !supplier.includes(item.SupplierName))
				supplier.push(item.SupplierName);
		});
		return supplier.length > 0 ? supplier[0] : "";
	}
	// .. Lấy địa chỉ nhà cung cấp theo chi tiết phiếu
	supplierAddress(){
		const details = this.details;
		var address = [];
		details.forEach(item => {
			if (item.SupplierAddress && !address.includes(item.SupplierAddress))
				address.push(item.SupplierAddress);
		});
		return address.length > 0 ? address[0] : "";
	}
	// .. Lấy tên người nhận theo chi tiết phiếu
	receiverInfo(){
		const details = this.details;
		var receiver = [];
		details.forEach(item => {
			if (item.Receiver && !receiver.includes(item.Receiver))
				receiver.push(item.Receiver);
		});
		return receiver.length > 0 ? receiver[0] : "";
	}
	// .. Lấy địa chỉ nhận theo chi tiết phiếu
	addressReceiveProduct(){
		const details = this.details;
		var addressReceiveProduct = [];
		details.forEach(item => {
			if (item.AddressReceiveProduct && !addressReceiveProduct.includes(item.AddressReceiveProduct))
				addressReceiveProduct.push(item.AddressReceiveProduct);
		});
		return addressReceiveProduct.length > 0 ? addressReceiveProduct[0] : "";
	}
	// ..
	setReceiver(){
		if (this.selectedReasonSupplierReturn())
			return this.supplierInfo();
		if (this.selecedOtherReason())
			return this.receiverInfo();
		return "";
	}
	// ..
	setAddress(){
		if (this.selectedReasonSupplierReturn())
			return this.supplierAddress();
		if (this.selecedOtherReason())
			return this.addressReceiveProduct();
		return "";
	}
}
